import { render } from "./FloatingActionButton.vue?vue&type=template&id=741af03c&scoped=true"
import script from "./FloatingActionButton.vue?vue&type=script&lang=js"
export * from "./FloatingActionButton.vue?vue&type=script&lang=js"

import "./FloatingActionButton.vue?vue&type=style&index=0&id=741af03c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741af03c"]])

export default __exports__